import { ROUTE_ACCOUNT } from '@/constants/routes';
import { TOAST_DEFAULT_OPTIONS } from '@/constants/toast';
import { useGetCommPreferences, useUpdateCommPreferences } from '@/queries/comm-preferences.queries';
import { useToast } from '@cmpsr/components';
import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { useBeforeUnload, useNavigate } from 'react-router-dom';

export default function useEditCommPreferencesPageController() {
  const { data: communicationPreferences, refetch } = useGetCommPreferences();
  const commPreferences = communicationPreferences?.preferences || [];

  const form = useForm({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    defaultValues: { preferences: commPreferences },
  });

  const updateCommPreferencesMutation = useUpdateCommPreferences();
  const toast = useToast();
  const navigate = useNavigate();

  const handleSaveCommPreferences = form.handleSubmit((values) => {
    const updatedPreferences = commPreferences.map((preference, index) => ({
      id: preference.id,
      title: preference.title,
      enabled: values.preferences[index].enabled,
    }));
    updateCommPreferencesMutation
      .mutateAsync(updatedPreferences)
      .then(() => {
        toast({
          ...TOAST_DEFAULT_OPTIONS,
          description: 'The info was updated successfully',
          status: 'success',
        });
        refetch();
        navigate(ROUTE_ACCOUNT);
      })
      .catch((error) => {
        console.error(error);
        toast({
          ...TOAST_DEFAULT_OPTIONS,
          title: `Error ${error.response?.data?.statusCode ?? ''}`,
          description: error.response?.data?.message ?? error.message,
          status: 'error',
        });
      });
  });

  useBeforeUnload(
    useCallback(
      (event) => {
        if (form.formState.isDirty) {
          event.preventDefault();
        }
      },
      [form.formState.isDirty]
    )
  );

  return { form, commPreferences, handleSaveCommPreferences };
}
